<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Değişiklik Nedeni</label>
            <input type="text" class="form-control" disabled readonly :value="$safe(status,'Reason')">
            <!-- <v-select-list :options="statuses" disabled v-model="status" label="Reason" placeholder="Değişiklik Nedeni"></v-select-list> -->
        </div>
        <div class="col-12" v-if="$safe(status,'ReasonCode') == 'CHANGE_PRICE'">
            <div class="row">
                <div class="col-12 mb-1" v-if="basePrice">
                    <div class="alert alert-info mb-0">
                        <div class="alert-body">
                            <strong>Değişiklik Talep Edilecek Tutar : </strong>{{basePrice || ""}} TL
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Talep Edilen Tutar</label>
                    <input type="text" v-mask="currencyMask" v-model="value.PriceStr" placeholder="Talep Edilen Tutar" class="form-control"/>
                </div>
            </div>
        </div>
        <div class="col-12" v-if="$safe(status,'ReasonCode') == 'ROUTE_ERROR'">
            <div class="row">
                <div class="col-12 mb-1" v-if="baseRoute">
                    <div class="alert alert-info mb-0">
                        <div class="alert-body">
                            <strong>Değişiklik Talep Edilecek Rota : </strong>{{baseRoute || ""}}
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">Başlangıç İli</label>
                            <v-select-list v-model="startProvince" :options="provinces" label="Name" v-on:input="getDistricts(true)" placeholder="Başlangıç İli"></v-select-list>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Başlangıç İlçesi</label>
                            <v-select-list v-model="startDistrict" :options="startDistricts" label="Name" placeholder="Başlangıç İlçesi"></v-select-list>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <label class="form-label">Bitiş İli</label>
                            <v-select-list v-model="endProvince" :options="provinces" label="Name" v-on:input="getDistricts(false)" placeholder="Bitiş İli"></v-select-list>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Bitiş İlçesi</label>
                            <v-select-list v-model="endDistrict" :options="endDistricts" label="Name" placeholder="Bitiş İlçesi"></v-select-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1" v-if="$safe(status,'ReasonCode') == 'DISTANCE_ERROR'">

        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea v-model="value.Description" class="form-control resize-none" placeholder="Açıklama"></textarea>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
const currencyMask = createNumberMask({
    prefix: '',
    suffix: '',
    allowDecimal: true,
    includeThousandsSeparator: true,
    decimalSymbol:',',
    thousandsSeparatorSymbol:'.',
    allowNegative: false,
});
export default {
    props:{
        value:Object
    },
    data(){
        return{
            statuses:[],
            provinces:[],
            startDistricts:[],
            endDistricts:[],
            baseRoute:null,
            basePrice:null,
            currencyMask,
        }
    },
    mounted(){
        this.getRequestStatuses().then(()=>{ this.setReason() })
        this.storeBaseRoute()
        this.storeBasePrice()
        this.getProvinces()
        this.getDistricts(true)
        this.getDistricts(false)
    },
    methods:{
        getRequestStatuses(){
            return new Promise((resolve)=>{
                SystemDataApi.DraftOfferPriceChangeRequestStatus().then(res=>{
                    this.statuses = res.data.Data
                    resolve()
                })
            })
        },
        getProvinces(){
            SystemDataApi.Province().then(response=>{
                this.provinces = response.data.Data
            })
        },
        getDistricts(bool){
            if(this.value.Route.StartProvinceId || this.value.Route.EndProvinceId){
                let id = bool ? this.value.Route.StartProvinceId : this.value.Route.EndProvinceId
                if(id){
                    SystemDataApi.District(id).then((res) => {
                        if(bool) this.startDistricts = res.data.Data
                        else this.endDistricts = res.data.Data
                    })
                }
            }
        },
        storeBaseRoute(){
            let startProvince = this.value.Route.StartProvinceName
            let startDistrict = this.value.Route.StartDistrictName
            let startNeighbourhood = this.value.Route.StartNeighbourhoodName
            let endProvince = this.value.Route.EndProvinceName
            let endDistrict = this.value.Route.EndDistrictName
            let endNeighbourhood = this.value.Route.EndNeighbourhoodName

            let baseRouteStartString = ""
            let baseRouteEndString = ""

            if(startNeighbourhood) baseRouteStartString = [startProvince,startDistrict,startNeighbourhood].join(', ')
            else baseRouteStartString = [startProvince,startDistrict].join(', ')

            if(endNeighbourhood) baseRouteEndString = [endProvince,endDistrict,endNeighbourhood].join(', ')
            else baseRouteEndString = [endProvince,endDistrict].join(', ')

            this.baseRoute = [baseRouteStartString,baseRouteEndString].join(' -> ')
        },
        storeBasePrice(){
            this.basePrice = this.value.Price
        },
        setReason(){
            let status = this.statuses.find(s=>s.ReasonCode == this.value.ReasonCode)
            this.value.DraftOfferPriceChangeRequestReasonId = status?.Id || null
            this.value.Reason = status?.Reason || null
        }
    },
    computed:{
        status:{
            get:function(){
                return this.statuses.find(b=>b.Id==this.value.DraftOfferPriceChangeRequestReasonId)
            },
            set:function(value){
                this.value.DraftOfferPriceChangeRequestReasonId = value?.Id || null
                this.value.Reason = value?.Reason || null
            }
        },
        startProvince:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.Route.StartProvinceId)
            },
            set:function(value){
                this.value.Route.StartProvinceId = value?.Id || null
                this.value.Route.StartProvinceName = value?.Name || null
            }
        },
        endProvince:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.Route.EndProvinceId)
            },
            set:function(value){
                this.value.Route.EndProvinceId = value?.Id || null
                this.value.Route.EndProvinceName = value?.Name || null
            }
        },
        startDistrict:{
            get:function(){
                return this.startDistricts.find(b=>b.Id==this.value.Route.StartDistrictId)
            },
            set:function(value){
                this.value.Route.StartDistrictId = value?.Id || null
                this.value.Route.StartDistrictName = value?.Name || null
            }
        },
        endDistrict:{
            get:function(){
                return this.endDistricts.find(b=>b.Id==this.value.Route.EndDistrictId)
            },
            set:function(value){
                this.value.Route.EndDistrictId = value?.Id || null
                this.value.Route.EndDistrictName = value?.Name || null
            }
        },

    }
}
</script>
